import React from "react"
import AdminPanel from "../components/AdminPanel"
import AppReleaseConfigPanel from "../components/AppReleaseConfigPanel"
import FeatureFlagConfigPanel from "../components/FeatureFlagConfigPanel"
import ProductConfigPanel from "../components/ProductConfigPanel"
import { useDashboardFilters } from "../state/dashboardFilters"

export default function SettingsPage() {
  const { adminOnly, setAdminOnly } = useDashboardFilters()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Settings</h1>
        <p className="text-muted-foreground">
          Manage admin controls, app releases, product configuration, and
          emergency notices.
        </p>
      </div>

      {/* Admin Controls */}
      <AdminPanel adminOnly={adminOnly} onAdminOnlyChange={setAdminOnly} />

      {/* App Release Configuration */}
      <AppReleaseConfigPanel />

      {/* Remote Feature Flags */}
      <FeatureFlagConfigPanel />

      {/* Product Configuration */}
      <ProductConfigPanel />
    </div>
  )
}
